import { PALMSUserPrograms } from 'collaboration-service';
import { Icon, Image, ImgIcons, Tooltip, aboveBreakpoint, aboveBreakpointOrEqual, useThemePart } from 'imaginarity-react-ui';
import * as React from 'react';
import { ApplicationState, useAppSelector } from 'services/ApplicationState/ApplicationState';
import { AccessHelpers, shallowCompare } from 'services/Helpers';
//import { createNamedRoute, gotoNamedRouteMethod } from 'services/Helpers/RoutingHelper';
import { gotoNamedRouteMethod } from 'services/Helpers/RoutingHelper';
import { getTranslatedStandardDate } from 'services/Helpers/TranslationHelpers';
import { useImgI18N } from 'services/ImgI18N';
import { ThemeContext } from 'styled-components';
import { getDateString } from 'views/MyHome/myHomeHelpers';
import { PlaylistSC as T } from './PlaylistSC';

const mapper = (state: ApplicationState) => ({ contentLanguage: state.contentLanguage, user: state.user });

export interface PlaylistOverviewLPItemProps {
    inputData: PALMSUserPrograms;
    ppnUserId: string;
    imgNbr: number;
    showActions?: boolean;
}

const PlaylistOverviewLPItem = (p: PlaylistOverviewLPItemProps) => {

    const { user } = useAppSelector(mapper, shallowCompare);
    const { t } = useImgI18N("myhomelearner");
    const [userProgram, setUserProgram] = React.useState<PALMSUserPrograms>();
    const [ppnId, setPpnId] = React.useState<string>();
    const [imageUrl, setImgurl] = React.useState<string>();
    const contentWidth = useThemePart(x => x.content.width);
    const theme = React.useContext(ThemeContext);
    const isTablet = aboveBreakpoint({ theme }, "largeMobile");
    const isLaptop = aboveBreakpointOrEqual({ theme }, "tablet");
    const isDesktop = aboveBreakpoint({ theme }, "desktop");
    const showDescs = contentWidth > 800;
    const tdy = getDateString(new Date());
    const dueDate = userProgram ? userProgram.deadLine : new Date();

    const getCurrentLearningStatus = React.useMemo(() => (): { icon: ImgIcons; color: string; ttColor: string; text: string; done: boolean } => {
        if ((userProgram?.programStatus[tdy].completedModules === userProgram?.programStatus[tdy]?.overallModules))
            return { icon: 'check circle', color: "@accentGreen", text: "done", done: true, ttColor: "@accentGreen" };
        if (userProgram?.programStatus[tdy].compliantModules === userProgram?.programStatus[tdy]?.overallModules)
            return { icon: 'clock', color: "@darkerGrey", text: "on Track", done: false, ttColor: "@accentGreen" };
        return { icon: 'exclamation triangle', color: "@accentRed", text: "overdue", done: false, ttColor: "@accentRed" };
    }, [userProgram, tdy]);

    React.useEffect(() => {
        setUserProgram(p.inputData);
        setPpnId(p.ppnUserId);
        setImgurl(`https://cdn.imaginarity.com/public/myhome/new/images/60-180-0${p.imgNbr ?? "05"}.jpg`);
    }, [p])
    const isGlobalAdmin = AccessHelpers.isGlobalAdmin()(user);

    const cls = getCurrentLearningStatus();
    const compliant = userProgram?.programStatus[tdy].compliantModules ?? -1;
    const completed = userProgram?.programStatus[tdy].completedModules ?? -1;
    const overall = userProgram?.programStatus[tdy].overallModules ?? -1
    return (
        <>
            <div />
            <T.PoiLogoContainer onClick={gotoNamedRouteMethod("learningPath", { id: userProgram?.id ?? "", ppnId: ppnId ?? "" })}>
                {<Image src={imageUrl ?? ""} squared borderColor='#FFF' />}
            </T.PoiLogoContainer>
            <T.PoiDescriptionContainer onClick={gotoNamedRouteMethod("learningPath", { id: userProgram?.id ?? "", ppnId: ppnId ?? "" })}>

                <div style={{ float: "left" }} className='nooverflow'>
                    {userProgram?.title}
                </div>
                {isGlobalAdmin ?
                    <div style={{ marginLeft: 10 }}>
                        <Tooltip tooltipText="" noMargin notInline position='top' tooltipContent={<div style={{ textAlign: "left", lineHeight: "20px" }}>This is a PALMS LearningPath<br /><small>Note only visible for global admins</small></div>}>
                            <span style={{ float: "right" }}>
                                <Icon name="info" style={{ margin: 0, transform: "translateY(4px)" }} color="@middleLightGrey" />
                            </span>
                        </Tooltip>
                    </div>
                    : <div />}
            </T.PoiDescriptionContainer>
            {showDescs ?
                <T.PoiDecriptionContainer onClick={gotoNamedRouteMethod("learningPath", { id: userProgram?.id ?? "", ppnId: ppnId ?? "" })}>
                    {userProgram?.id}
                </T.PoiDecriptionContainer>
                : <div />
            }
            {isDesktop ?
                <T.PoiAssignContainer>
                    <Icon name="times" color='@middleLightGrey' style={{ float: "left" }} size="16px" marginTop={3} />
                </T.PoiAssignContainer>
                : <div />
            }
            {isTablet ?
                <T.PoiDueToContainer color={cls.ttColor
                }>
                    {getTranslatedStandardDate(dueDate, "PP")}
                </T.PoiDueToContainer>
                : <div />
            }
            {isLaptop ?
                <T.PoiDurationContainer>
                    <Icon name="times" color='@middleLightGrey' style={{ float: "left" }} size="16px" marginTop={3} />
                </T.PoiDurationContainer>
                : <div />
            }

            <T.PoiProgressContainer color={cls.done ? "@accentGreen" : cls.color}>
                <Tooltip tooltipText="" noMargin notInline position='top' cursor='default'
                    tooltipContent={
                        <div style={{ textAlign: "left", lineHeight: "20px" }}>
                            Showing completion<br /><T.PoiProgressInfoContainer color={cls.ttColor}>Complinace {compliant}/{overall} </T.PoiProgressInfoContainer>
                        </div>}>
                    <div>
                        <Icon name={cls.done ? "check circle" : cls.icon}
                            color={cls.done ? "@accentGreen" : cls.color}
                            size={18} marginTop={4}
                            style={{ float: "left", marginRight: 5 }}
                        />

                        <span style={{ float: "left", marginRight: 5 }}>
                            {t(cls.text)}
                        </span>
                        <span style={{ float: "left", marginLeft: 5 }}>
                            <>{completed}/{overall}</>
                        </span>
                    </div>
                </Tooltip>


            </T.PoiProgressContainer>
            {p.showActions &&
                <T.PoiAssignContainer>
                    <Icon name="times" color='@middleLightGrey' style={{ float: "left", marginLeft: 11 }} size="16px" marginTop={3} />
                </T.PoiAssignContainer>
            }
            <div />
        </>
    );
}
export default PlaylistOverviewLPItem;
